import { css } from '@emotion/react'
import * as React from 'react'
import { DateLike, timeZoneAbbreviation } from '../../../util/dateTime'

const labelStyle = css`
  font-size: 0.85em;
  color: #667085;
  margin-left: 0.35em;
  white-space: nowrap;
`

// The venue zone a time is displayed in, e.g. "ET". Deliberately quiet — it
// sits a tier below the time itself so it reads as metadata, not as part of
// the time. `on` matters because the abbreviation is date-dependent in zones
// that observe daylight saving.
const TimeZoneLabel: React.FC<{ timeZone: string; on?: DateLike }> = ({ timeZone, on }) => {
  const abbreviation = timeZoneAbbreviation(timeZone, on)
  if (!abbreviation) return null

  return <span css={labelStyle}>{abbreviation}</span>
}

export default TimeZoneLabel
